export const CountryStates = {    
    "AF" : {"name" : "Afghanistan"},
    "AL" : {"name" : "Albania"},
    "DZ" : {"name" : "Algeria"},
    "AS" : {"name" : "American Samoa"},
    "AD" : {"name" : "Andorra"},
    "AO" : {"name" : "Angola"},
    "AI" : {"name" : "Anguilla"},
    "AQ" : {"name" : "Antarctica"},
    "AG" : {"name" : "Antigua And Barbuda"},
    "AR" : {"name" : "Argentina"},
    "AM" : {"name" : "Armenia"},
    "AW" : {"name" : "Aruba"},
    "AU" : {
        "name" : "Australia",
        "states" : {
            "ACT" : {"name" : "Australian Capital Territory"},
            "JBT" : {"name" : "Jervis Bay Territory"},
            "NSW" : {"name" : "New South Wales"},
            "NT" : {"name" : "Northern Territory"},
            "QLD" : {"name" : "Queensland"},
            "SA" : {"name" : "South Australia"},
            "TAS" : {"name" : "Tasmania"},
            "VIC" : {"name" : "Victoria"},
            "WA" : {"name" : "Western Australia"}
        }
    },
    "AT" : {"name" : "Austria"},
    "AZ" : {"name" : "Azerbaijan"},
    "BS" : {"name" : "Bahamas"},
    "BH" : {"name" : "Bahrain"},
    "BD" : {"name" : "Bangladesh"},
    "BB" : {"name" : "Barbados"},
    "BY" : {"name" : "Belarus"},
    "BE" : {"name" : "Belgium"},
    "BZ" : {"name" : "Belize"},
    "BJ" : {"name" : "Benin"},
    "BM" : {"name" : "Bermuda"},
    "BT" : {"name" : "Bhutan"},
    "BO" : {"name" : "Bolivia"},
    "BA" : {"name" : "Bosnia And Herzegowina"},
    "BW" : {"name" : "Botswana"},
    "BV" : {"name" : "Bouvet Island"},
    "BR" : {"name" : "Brazil"},
    "IO" : {"name" : "British Indian Ocean Territory"},
    "BN" : {"name" : "Brunei Darussalam"},
    "BG" : {"name" : "Bulgaria"},
    "BF" : {"name" : "Burkina Faso"},
    "BI" : {"name" : "Burundi"},
    "KH" : {"name" : "Cambodia"},
    "CM" : {"name" : "Cameroon"},
    "CA" : {
        "name" : "Canada",
        "states" : {
            "AB" : {"name" : "Alberta"},
            "BC" : {"name" : "British Columbia"},
            "MB" : {"name" : "Manitoba"},
            "NB" : {"name" : "New Brunswick"},
            "NF" : {"name" : "Newfoundland and Labrador"},
            "NT" : {"name" : "Northwest Territories"},
            "NS" : {"name" : "Nova Scotia"},
            "NU" : {"name" : "Nunavut"},
            "ON" : {"name" : "Ontario"},
            "PE" : {"name" : "Prince Edward Island"},
            "QC" : {"name" : "Quebec"},
            "SK" : {"name" : "Saskatchewan"},
            "YT" : {"name" : "Yukon Territory"}
        }
    },
    "CV" : {"name" : "Cape Verde"},
    "KY" : {"name" : "Cayman Islands"},
    "CF" : {"name" : "Central African Republic"},
    "TD" : {"name" : "Chad"},
    "CL" : {"name" : "Chile"},
    "CN" : {"name" : "China"},
    "CX" : {"name" : "Christmas Island"},
    "CC" : {"name" : "Cocos (Keeling) Islands"},
    "CO" : {"name" : "Colombia"},
    "KM" : {"name" : "Comoros"},
    "CG" : {"name" : "Congo"},
    "CD" : {"name" : "Congo, The Democratic Republic Of The"},
    "CK" : {"name" : "Cook Islands"},
    "CR" : {"name" : "Costa Rica"},
    "CI" : {"name" : "Cote D\"Ivoire"},
    "HR" : {"name" : "Croatia (Local Name: Hrvatska)"},
    "CU" : {"name" : "Cuba"},
    "CY" : {"name" : "Cyprus"},
    "CZ" : {"name" : "Czech Republic"},
    "DK" : {"name" : "Denmark"},
    "DJ" : {"name" : "Djibouti"},
    "DM" : {"name" : "Dominica"},
    "DO" : {"name" : "Dominican Republic"},
    "TP" : {"name" : "East Timor"},
    "EC" : {"name" : "Ecuador"},
    "EG" : {"name" : "Egypt"},
    "SV" : {"name" : "El Salvador"},
    "GQ" : {"name" : "Equatorial Guinea"},
    "ER" : {"name" : "Eritrea"},
    "EE" : {"name" : "Estonia"},
    "ET" : {"name" : "Ethiopia"},
    "FK" : {"name" : "Falkland Islands (Malvinas)"},
    "FO" : {"name" : "Faroe Islands"},
    "FJ" : {"name" : "Fiji"},
    "FI" : {"name" : "Finland"},
    "FR" : {"name" : "France"},
    "FX" : {"name" : "France, Metropolitan"},
    "GF" : {"name" : "French Guiana"},
    "PF" : {"name" : "French Polynesia"},
    "TF" : {"name" : "French Southern Territories"},
    "GA" : {"name" : "Gabon"},
    "GM" : {"name" : "Gambia"},
    "GE" : {"name" : "Georgia"},
    "DE" : {"name" : "Germany"},
    "GH" : {"name" : "Ghana"},
    "GI" : {"name" : "Gibraltar"},
    "GR" : {"name" : "Greece"},
    "GL" : {"name" : "Greenland"},
    "GD" : {"name" : "Grenada"},
    "GP" : {"name" : "Guadeloupe"},
    "GU" : {"name" : "Guam"},
    "GT" : {"name" : "Guatemala"},
    "GN" : {"name" : "Guinea"},
    "GW" : {"name" : "Guinea-Bissau"},
    "GY" : {"name" : "Guyana"},
    "HT" : {"name" : "Haiti"},
    "HM" : {"name" : "Heard And Mc Donald Islands"},
    "HN" : {"name" : "Honduras"},
    "HK" : {"name" : "Hong Kong"},
    "HU" : {"name" : "Hungary"},
    "IS" : {"name" : "Iceland"},
    "IN" : {"name" : "India"},
    "ID" : {"name" : "Indonesia"},
    "IR" : {"name" : "Iran (Islamic Republic Of)"},
    "IQ" : {"name" : "Iraq"},
    "IE" : {"name" : "Ireland"},
    "IL" : {"name" : "Israel"},
    "IT" : {"name" : "Italy"},
    "JM" : {"name" : "Jamaica"},
    "JP" : {"name" : "Japan"},
    "JO" : {"name" : "Jordan"},
    "KZ" : {"name" : "Kazakhstan"},
    "KE" : {"name" : "Kenya"},
    "KI" : {"name" : "Kiribati"},
    "KP" : {"name" : "Korea, Democratic People\"S Republic Of"},
    "KR" : {"name" : "Korea, Republic Of"},
    "KW" : {"name" : "Kuwait"},
    "KG" : {"name" : "Kyrgyzstan"},
    "LA" : {"name" : "Lao People\"S Democratic Republic"},
    "LV" : {"name" : "Latvia"},
    "LB" : {"name" : "Lebanon"},
    "LS" : {"name" : "Lesotho"},
    "LR" : {"name" : "Liberia"},
    "LY" : {"name" : "Libyan Arab Jamahiriya"},
    "LI" : {"name" : "Liechtenstein"},
    "LT" : {"name" : "Lithuania"},
    "LU" : {"name" : "Luxembourg"},
    "MO" : {"name" : "Macau"},
    "MK" : {"name" : "Macedonia, Former Yugoslav Republic Of"},
    "MG" : {"name" : "Madagascar"},
    "MW" : {"name" : "Malawi"},
    "MY" : {"name" : "Malaysia"},
    "MV" : {"name" : "Maldives"},
    "ML" : {"name" : "Mali"},
    "MT" : {"name" : "Malta"},
    "MH" : {"name" : "Marshall Islands, Republic of the"},
    "MQ" : {"name" : "Martinique"},
    "MR" : {"name" : "Mauritania"},
    "MU" : {"name" : "Mauritius"},
    "YT" : {"name" : "Mayotte"},
    "MX" : {"name" : "Mexico"},
    "FM" : {"name" : "Micronesia, Federated States Of"},
    "MD" : {"name" : "Moldova, Republic Of"},
    "MC" : {"name" : "Monaco"},
    "MN" : {"name" : "Mongolia"},
    "MS" : {"name" : "Montserrat"},
    "MA" : {"name" : "Morocco"},
    "MZ" : {"name" : "Mozambique"},
    "MM" : {"name" : "Myanmar"},
    "NA" : {"name" : "Namibia"},
    "NR" : {"name" : "Nauru"},
    "NP" : {"name" : "Nepal"},
    "NL" : {"name" : "Netherlands"},
    "AN" : {"name" : "Netherlands Antilles"},
    "NC" : {"name" : "New Caledonia"},
    "NZ" : {"name" : "New Zealand"},
    "NI" : {"name" : "Nicaragua"},
    "NE" : {"name" : "Niger"},
    "NG" : {"name" : "Nigeria"},
    "NU" : {"name" : "Niue"},
    "NF" : {"name" : "Norfolk Island"},
    "MP" : {"name" : "Northern Mariana Islands, Commonwealth of the"},
    "NO" : {"name" : "Norway"},
    "OM" : {"name" : "Oman"},
    "PK" : {"name" : "Pakistan"},
    "PW" : {"name" : "Palau, Republic of"},
    "PA" : {"name" : "Panama"},
    "PG" : {"name" : "Papua New Guinea"},
    "PY" : {"name" : "Paraguay"},
    "PE" : {"name" : "Peru"},
    "PH" : {"name" : "Philippines"},
    "PN" : {"name" : "Pitcairn"},
    "PL" : {"name" : "Poland"},
    "PT" : {"name" : "Portugal"},
    "PR" : {"name" : "Puerto Rico"},
    "QA" : {"name" : "Qatar"},
    "RE" : {"name" : "Reunion"},
    "RO" : {"name" : "Romania"},
    "RU" : {"name" : "Russian Federation"},
    "RW" : {"name" : "Rwanda"},
    "KN" : {"name" : "Saint Kitts And Nevis"},
    "LC" : {"name" : "Saint Lucia"},
    "VC" : {"name" : "Saint Vincent And The Grenadines"},
    "WS" : {"name" : "Samoa"},
    "SM" : {"name" : "San Marino"},
    "ST" : {"name" : "Sao Tome And Principe"},
    "SA" : {"name" : "Saudi Arabia"},
    "SN" : {"name" : "Senegal"},
    "SC" : {"name" : "Seychelles"},
    "SL" : {"name" : "Sierra Leone"},
    "SG" : {"name" : "Singapore"},
    "SK" : {"name" : "Slovakia (Slovak Republic)"},
    "SI" : {"name" : "Slovenia"},
    "SB" : {"name" : "Solomon Islands"},
    "SO" : {"name" : "Somalia"},
    "ZA" : {"name" : "South Africa"},
    "GS" : {"name" : "South Georgia, South Sandwich Islands"},
    "ES" : {"name" : "Spain"},
    "LK" : {"name" : "Sri Lanka"},
    "SH" : {"name" : "St. Helena"},
    "PM" : {"name" : "St. Pierre And Miquelon"},
    "SD" : {"name" : "Sudan"},
    "SR" : {"name" : "Suriname"},
    "SJ" : {"name" : "Svalbard And Jan Mayen Islands"},
    "SZ" : {"name" : "Swaziland"},
    "SE" : {"name" : "Sweden"},
    "CH" : {"name" : "Switzerland"},
    "SY" : {"name" : "Syrian Arab Republic"},
    "TW" : {"name" : "Taiwan"},
    "TJ" : {"name" : "Tajikistan"},
    "TZ" : {"name" : "Tanzania, United Republic Of"},
    "TH" : {"name" : "Thailand"},
    "TG" : {"name" : "Togo"},
    "TK" : {"name" : "Tokelau"},
    "TO" : {"name" : "Tonga"},
    "TT" : {"name" : "Trinidad And Tobago"},
    "TN" : {"name" : "Tunisia"},
    "TR" : {"name" : "Turkey"},
    "TM" : {"name" : "Turkmenistan"},
    "TC" : {"name" : "Turks And Caicos Islands"},
    "TV" : {"name" : "Tuvalu"},
    "UG" : {"name" : "Uganda"},
    "UA" : {"name" : "Ukraine"},
    "AE" : {"name" : "United Arab Emirates"},
    "GB" : {"name" : "United Kingdom"},
    "UM" : {"name" : "United States Minor Outlying Islands"},
    "US" : {
        "name" : "United States",
        "states" : {
            "AL" : {"name" : "Alabama"},
            "AK" : {"name" : "Alaska"},
            "AZ" : {"name" : "Arizona"},
            "AR" : {"name" : "Arkansas"},
            "CA" : {"name" : "California"},
            "CO" : {"name" : "Colorado"},
            "CT" : {"name" : "Connecticut"},
            "DE" : {"name" : "Delaware"},
            "DC" : {"name" : "District of Columbia"},
            "FL" : {"name" : "Florida"},
            "GA" : {"name" : "Georgia"},
            "HI" : {"name" : "Hawaii"},
            "ID" : {"name" : "Idaho"},
            "IL" : {"name" : "Illinois"},
            "IN" : {"name" : "Indiana"},
            "IA" : {"name" : "Iowa"},
            "KS" : {"name" : "Kansas"},
            "KY" : {"name" : "Kentucky"},
            "LA" : {"name" : "Louisiana"},
            "ME" : {"name" : "Maine"},
            "MD" : {"name" : "Maryland"},
            "MA" : {"name" : "Massachusetts"},
            "MI" : {"name" : "Michigan"},
            "MN" : {"name" : "Minnesota"},
            "MS" : {"name" : "Mississippi"},
            "MO" : {"name" : "Missouri"},
            "MT" : {"name" : "Montana"},
            "NE" : {"name" : "Nebraska"},
            "NV" : {"name" : "Nevada"},
            "NH" : {"name" : "New Hampshire"},
            "NJ" : {"name" : "New Jersey"},
            "NM" : {"name" : "New Mexico"},
            "NY" : {"name" : "New York"},
            "NC" : {"name" : "North Carolina"},
            "ND" : {"name" : "North Dakota"},
            "OH" : {"name" : "Ohio"},
            "OK" : {"name" : "Oklahoma"},
            "OR" : {"name" : "Oregon"},
            "PA" : {"name" : "Pennsylvania"},
            "RI" : {"name" : "Rhode Island"},
            "SC" : {"name" : "South Carolina"},
            "SD" : {"name" : "South Dakota"},
            "TN" : {"name" : "Tennessee"},
            "TX" : {"name" : "Texas"},
            "UT" : {"name" : "Utah"},
            "VT" : {"name" : "Vermont"},
            "VA" : {"name" : "Virginia"},
            "WA" : {"name" : "Washington"},
            "WV" : {"name" : "West Virginia"},
            "WI" : {"name" : "Wisconsin"},
            "WY" : {"name" : "Wyoming"}
        }
    },
    "UY" : {"name" : "Uruguay"},
    "UZ" : {"name" : "Uzbekistan"},
    "VU" : {"name" : "Vanuatu"},
    "VA" : {"name" : "Vatican City, State of the"},
    "VE" : {"name" : "Venezuela"},
    "VN" : {"name" : "Viet Nam"},
    "VG" : {"name" : "Virgin Islands (British)"},
    "VI" : {"name" : "Virgin Islands (U.S.)"},
    "WF" : {"name" : "Wallis And Futuna Islands"},
    "EH" : {"name" : "Western Sahara"},
    "YE" : {"name" : "Yemen"},
    "YU" : {"name" : "Yugoslavia"},
    "ZM" : {"name" : "Zambia"},
    "ZW" : {"name" : "Zimbabwe"}
}